import { Controller } from "remult";

@Controller("sub-category-methods")
export class SubCategoryMethods {}
